import { Box, Grid, Typography } from '@mui/material';
import DisplayField from '@acorn-portal/shared/src/components/displayField';
import { formatCurrency } from '@acorn-portal/shared/src/utils';
import { GetPaymentDetailsResponseModel } from '@acorn-portal/shared/src/services/api';

interface IProps {
	details: GetPaymentDetailsResponseModel;
}

const DirectDebitField = ({ details }: IProps) => {
	return (
		<Box
			sx={(theme) => ({
				border: `1px solid ${theme.palette.divider}`,
				p: 2,
				width: '100%',
				my: 1,
				borderRadius: 2,
			})}
		>
			<Typography variant='h6' color='secondary' sx={{ mb: 2 }}>
				Remaining Payments
			</Typography>
			<Grid size={{ xs: 10, md: 12 }}>
				<DisplayField label='Total Amount'>{formatCurrency(details.totalBalanceOutstanding ?? 0)}</DisplayField>
			</Grid>

			{details.amountDueOnNextDirectDebit !== 0 && (
				<Grid size={{ xs: 10, md: 12 }}>
					<DisplayField label='Amount due on next Direct Debit'>
						{formatCurrency(details.amountDueOnNextDirectDebit ?? 0)}
					</DisplayField>
				</Grid>
			)}
		</Box>
	);
};

export default DirectDebitField;
